import { useState, useEffect } from "react";
import { CALENDAR_CONFIG } from "@/config/rooms";

export function useCurrentTime(
  updateInterval = CALENDAR_CONFIG.timeUpdateInterval
) {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, updateInterval);

    return () => clearInterval(interval);
  }, [updateInterval]);

  return currentTime;
}
